export default class RoleTypes {
    static Admin = 'Admin'
    static Operator = 'Operator'
    static Viewer = 'Viewer'
  }